module.exports = __webpack_public_path__ + "assets/img/icon-7.fc623e5d.png";